export default {
  path: '/:pathMatch(.*)*',
  name: '404',
  component: () => import('@/views/errors/404.vue').then((m) => m.default),
};
